import React from "react";
import Hero from "../components/Hero";

function Home() {
  return (
    <main className="home-page">
      <Hero />
    
    </main>
  );
}

export default Home;